module.exports = __webpack_public_path__ + "img/Wallet-Mercadopago.610a375.png";